<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Course And Seminar Title</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="serminarCourse.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="serminarCourse.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Seminar Type"
              v-model="serminarCourse.semTypeDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearSemClass"
            >
              <template slot="append">
                <v-icon @click.stop="searchSemType">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Seminar Classification"
              v-model="serminarCourse.semClassDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearSemClass"
            >
              <template slot="append">
                <v-icon @click.stop="searchSemClass">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="CPE"
              :class="classPadding"
              v-model="cpe"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row v-if="cpe">
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Accredited Body"
              v-model="serminarCourse.accreditDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearAccredited"
            >
              <template slot="append">
                <v-icon @click.stop="searchAccredited">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-checkbox
              label="Is Active"
              :class="classPadding"
              v-model="serminarCourse.isActive"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>

      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">

        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>

      </pagination>

      <v-dialog v-model="editDialog" width="900" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editSerminarCourse.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editSerminarCourse.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Seminar Type"
                  v-model="editSerminarCourse.semTypeDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearSemClass"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchSemType">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Seminar Classification"
                  v-model="editSerminarCourse.semClassDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearSemClass"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchSemClass">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                <v-checkbox
                  label="CPE"
                  :class="classPadding"
                  v-model="editCPE"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row v-if="editCPE">
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Accredited Body"
                  v-model="editSerminarCourse.accreditDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearAccredited"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchAccredited">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                <v-checkbox
                  label="Is Active"
                  :class="classPadding"
                  v-model="editSerminarCourse.isActive"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Seminar Type -->
      <v-dialog v-model="semTypeDialog" width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Seminar Type</span>
          </v-card-title>
          <v-card-text>
            <sem-type :show-title="false" :show-dense="false">
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectSemType(item)" text>Select</v-btn>
              </template>
            </sem-type>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.prevent="semTypeDialog = false" text
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Seminar Class -->
      <v-dialog v-model="semClassDialog" width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Seminar Classification</span>
          </v-card-title>
          <v-card-text>
            <sem-class :show-title="false" :show-dense="false">
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectSemClass(item)" text>Select</v-btn>
              </template>
            </sem-class>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.prevent="semClassDialog = false" text
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Accredited Body -->
      <v-dialog v-model="accreditedDialog" width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Accredited Body</span>
          </v-card-title>
          <v-card-text>
            <accredited-body :show-title="false" :show-dense="false">
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectAccredited(item)" text>Select</v-btn>
              </template>
            </accredited-body>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.prevent="accreditedDialog = false" text
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import SemClass from "../seminar-class/List";
import SemType from "../seminar-type/Pagination";
import AccreditedBody from "../seminar-accredit/Pagination";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
// import List from "./List";
const API_ENDPOINT = "/api/seminarCourse";
export default {
  metaInfo: {
    title: "Course And Seminar Title",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List
    Pagination,
    SemClass,
    SemType,
    AccreditedBody
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    serminarCourse: {},
    componentKey: 0,
    editSerminarCourse: {},
    editDialog: false,
    semClassDialog: false,
    semTypeDialog: false,
    accreditedDialog: false,
    cpe: false,
    editCPE: false
  }),
  methods: {
    // ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.serminarCourse)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editSerminarCourse.code = rel.code;
      this.editSerminarCourse.desc = rel.desc;
      this.editSerminarCourse.seminarType = rel.semType;
      this.editSerminarCourse.semTypeDesc = rel.semTypeDesc;
      this.editSerminarCourse.seminarClass = rel.semClass;
      this.editSerminarCourse.semClassDesc = rel.semClassDesc;
      this.editSerminarCourse.accreditCode = rel.accreditCode;
      this.editSerminarCourse.accreditDesc = rel.accreditDesc;
      this.editCPE = rel.accreditBit;
      this.editSerminarCourse.isActive = rel.isActive;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.code}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.serminarCourse = {};
      this.forceRerender();
      this.editDialog = false;
      this.cpe = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editSerminarCourse)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchSemClass() {
      this.semClassDialog = true;
    },
    selectSemClass(item) {
      if (!this.editDialog) {
        this.serminarCourse.semClassDesc = item.desc;
        this.serminarCourse.seminarClass = item.code;
      } else {
        this.editSerminarCourse.semClassDesc = item.desc;
        this.editSerminarCourse.seminarClass = item.code;
      }
      this.semClassDialog = false;
    },
    clearSemClass() {
      if (!this.editDialog) {
        this.serminarCourse.semClassDesc = null;
        this.serminarCourse.seminarClass = null;
      } else {
        this.editSerminarCourse.semClassDesc = null;
        this.editSerminarCourse.seminarClass = null;
      }
    },
    searchSemType() {
      this.semTypeDialog = true;
    },
    selectSemType(item) {
      if (!this.editDialog) {
        this.serminarCourse.semTypeDesc = item.desc;
        this.serminarCourse.seminarType = item.code;
      } else {
        this.editSerminarCourse.semTypeDesc = item.desc;
        this.editSerminarCourse.seminarType = item.code;
      }
      this.semTypeDialog = false;
    },
    clearSemType() {
      if (!this.editDialog) {
        this.serminarCourse.semTypeDesc = null;
        this.serminarCourse.seminarType = null;
      } else {
        this.editSerminarCourse.semTypeDesc = null;
        this.editSerminarCourse.seminarType = null;
      }
    },
    searchAccredited() {
      this.accreditedDialog = true;
    },
    selectAccredited(item) {
      if (!this.editDialog) {
        this.serminarCourse.accreditDesc = item.accreditDesc;
        this.serminarCourse.accreditCode = item.accreditCode;
      } else {
        this.editSerminarCourse.accreditDesc = item.accreditDesc;
        this.editSerminarCourse.accreditCode = item.accreditCode;
      }
      this.accreditedDialog = false;
    },
    clearAccredited() {
      if (!this.editDialog) {
        this.serminarCourse.accreditDesc = null;
        this.serminarCourse.accreditCode = null;
      } else {
        this.editSerminarCourse.accreditDesc = null;
        this.editSerminarCourse.accreditCode = null;
      }
    }
  },
  watch: {
    cpe(val) {
      this.serminarCourse.accredited = val;
    },
    editCPE(val) {
      this.editSerminarCourse.accredited = val;
    }
  },
  created() {
    this.getUserAccessRights("CourseNSem");
  }
};
</script>